module.exports = __webpack_public_path__ + "img/4.f54656f2.png";